<template>
    <div>
        <h3 class="popup-tilte" v-if="!getBikaImportInvalidEmail">Ez az email cím már szerepel az adatbázisban!</h3>
        <h3 class="popup-tilte" v-if="getBikaImportInvalidEmail">Érvénytelen vagy üres email cím!</h3>
        <div v-if="getOtherConsultantName">Ez az ügyfél a(z) {{ getOtherConsultantName }} tanácsadóhoz tartozik.</div>
        <div>Amennyiben új profilt szeretne létrehozni ezekkel az adatokkal, adjon meg egy egyedi email címet és kattintson a regisztráció gombra.</div>
        <ValidationObserver ref="form" slim v-slot="{ invalid }">
            <div class="popup-form form">

                <ValidationProvider
                    name="E-mail cím"
                    rules="required|email"
                    v-slot="{ errors, classes }"
                    slim
                    mode="eager"
                >
                    <div class="d-table w-100 mb-30px">
                        <div :class="classes">
                            <input
                                type="email"
                                placeholder="Új E-mail cím"
                                class=""
                                v-model="email"
                                inputmode="email"
                                data-hj-allow
                            />
                        </div>
                        <span class="error_message error_message--broke">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <span class="d-flex error_message error_message--broke justify-center mb-15px mt-12px" v-if="error">
					{{ error }}
				</span>
                <div class="con-1334 navBtn">
                    <a class="navBtn-prev" @click="handleCancel">Mégse</a>
                    <LoadingButton
                        class="navBtn-next btn btn-blue"
                        text="Rögzítés"
                        :disabled="invalid"
                        @click="handleRegistration"
                        :loading="getLoading"
                    />
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import LoadingButton from '@/components/elements/LoadingButton';

export default {
    components: {
        LoadingButton,
    },
    data() {
        return {
            email: null,
            error: null,
        };
    },
    computed: {
        ...mapGetters(['getLoading', 'getLoadingBikaId', 'getOtherConsultantName','getBikaImportInvalidEmail']),
    },
    methods: {
        ...mapMutations(['showPopup', 'setLoading','setLoadingBikaId']),
        ...mapActions('auth', ['register']),
        ...mapActions(['saveCalculationData', 'calculate']),
        ...mapActions('auth', ['simpleRegister']),
        async handleRegistration() {
            this.$refs.form.validate().then(async success => {
                if (success) {
                    this.setLoading(true);
                    const response = await this.simpleRegister({
                        bika_id: this.getLoadingBikaId,
                        email: this.email,
                    });
                    this.setLoading(false);
                    if (response.success) {
                        this.setLoadingBikaId(null);
                        await this.$router.push(`/${response.user}`);
                        this.showPopup(null);
                    } else {
                        this.error = response.message;
                    }
                }
            });
        },
        async handleCancel() {
            this.setLoadingBikaId(null);
            this.showPopup(null);
        }
    },
};
</script>
